<template>
  <div class="page-content" :style="backgroundStyle">
    <component
      v-for="item in pageConfig.componentConfig"
      :id="item.id"
      :key="item.id"
      :is="item.component"
      :cid="item.componentId"
      :tags="item.tags"
      :uid="item.id"
      :uname="item.name"
      :ref="item.id"
      :styles="item.styles"
      :configuration-data="item.configurationData"
      :interval-data-fetch-list="item.intervalDataFetchList"
      :events="item.events"
      @component-event-emitted="handleComponentEvents(arguments, item.id)"
      @defined-event-emitted="handleDefinedEvents"
    >
      <template v-for="(value, name) in item.childrenSlots" #[name]>
        <template v-for="child in value">
          <component
            :id="child.id"
            :key="child.id"
            :is="child.component"
            :cid="child.componentId"
            :tags="child.tags"
            :uid="child.id"
            :uname="child.name"
            :ref="child.id"
            :styles="child.styles"
            :configuration-data="child.configurationData"
            :interval-data-fetch-list="child.intervalDataFetchList"
            :events="child.events"
            @component-event-emitted="handleComponentEvents(arguments, child.id)"
            @defined-event-emitted="handleDefinedEvents"
          />
        </template>
      </template>
    </component>
  </div>
</template>
<script>
// 默认fetch
import mixin from '@tencent/ceiba-ui/ui-mixin';
import { common } from '@tencent/ceiba-base-components';

export default {
  name: 'CPageH5',
  mixins: [mixin],
  data() {
    return {};
  },
  computed: {
    // 背景样式
    backgroundStyle() {
      let resolution = '750*1334';
      if (this.pageConfig.canvasConfig) {
        resolution = this.pageConfig.canvasConfig.resolution;
      }
      const [width, height] = resolution.split('*');
      const resolutionStyle = common.tool.transformStyle({
        width: `${width}px`,
        height: `${height}px`,
      });
      const { canvasConfig } = this.pageConfig;
      canvasConfig.background = canvasConfig.background || canvasConfig.backgroundColor;
      const bgColorStyle = { backgroundColor: canvasConfig.background };
      const canvasContainerStyle = Object.assign({}, bgColorStyle, resolutionStyle);
      const { backgroundImage } = canvasConfig; // 画布背景图片
      if (backgroundImage) {
        const { equalScale, src, alignMiddle } = backgroundImage;
        if (typeof src !== 'undefined') {
          canvasContainerStyle.backgroundImage = `url(${src})`; // 图片 url
        }
        if (alignMiddle === true) {
          // 图片居中顶部展示
          canvasContainerStyle.backgroundPosition = 'center 0%';
          canvasContainerStyle.backgroundSize = 'auto';
        } else {
          canvasContainerStyle.backgroundSize = equalScale ? 'auto 100%' : 'cover'; // 图片 缩放
        }
      }
      return canvasContainerStyle;
    },
  },
  methods: {
    hookOnContainerChange() {
      // 计算rem
      if (typeof document !== 'undefined') {
        const rootHtml = document.documentElement;
        rootHtml.style.fontSize = `${100 * (rootHtml.clientWidth / 750)}px`;
        console.log(
          'h5 deviceMode=',
          this.deviceMode,
          'html.clientWidth=',
          rootHtml.clientWidth,
          'html.clientHeight=',
          rootHtml.clientHeight,
          rootHtml.style.fontSize,
        );

        //  微信和 浏览器 内不进行重新校验html的内敛的fontSize 与 实际的getComputedStyle的获得最终的fontSize
        //  该bug存在部分机型的QQ客户端
        // if (!this.$platform.isQQ) {
        //   return;
        // }
        // if (!rootHtml.clientWidth) {
        //   console.log('!rootHtml.clientWidth');
        //   return;
        // }
        // const remSize = rootHtml.style.fontSize.split('p')[0];
        // console.log('remSize==', remSize);

        // if (isNaN(remSize)) {
        //   return;
        // }
        // if (typeof window !== 'undefined') {
        //   const currentFontSize = window.getComputedStyle(document.getElementsByTagName('html')[0]).fontSize;
        //   const [currentSize] = currentFontSize.split('p');
        //   console.log('currentSize=', currentSize);
        //   if (isNaN(currentSize)) {
        //     return;
        //   }
        //   const rate = currentSize / remSize;
        //   if (rate !== 1) {
        //     rootHtml.style.fontSize = `${remSize / rate}px`;
        //   }
        //   console.log('reset fontsize=', rootHtml.style.fontSize);
        // }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@tencent/ceiba-base-components/index.scss';
@import './styles.scss';

.page-content {
  position: relative;
}

.page-background {
  position: absolute;
  width: 100%;
}
</style>
